import type { DeckardIcon } from '@assets/icons';
import { Button } from '@components/button';
import { Menu, useTheme } from '@mui/material';
import type { PropsWithChildren } from 'react';

type HeaderMenuProps = {
  anchorEl: HTMLElement;
  icon: DeckardIcon;
  ariaLabel: string;
  setAnchorEl: (anchor: HTMLElement) => void;
};

export const HeaderMenu = ({
  anchorEl,
  children,
  icon: Icon,
  ariaLabel,
  setAnchorEl,
}: PropsWithChildren<HeaderMenuProps>) => {
  const { palette } = useTheme();

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Button
        aria-label={ariaLabel}
        sx={{
          color: 'common.white',
          px: 3,
          backgroundColor: anchorEl ? palette.grey[800] : 'transparent',
          border: 'none',
          display: 'flex',
          justifyContent: 'center',
          '& svg': { stroke: anchorEl ? palette.grey[200] : palette.grey[500] },
          '&:hover': {
            backgroundColor: anchorEl ? palette.grey[800] : 'transparent',
            cursor: 'pointer',
            '& svg': {
              stroke: palette.grey[200],
            },
          },
        }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Icon size={20} color={palette.grey[500]} />
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          '& .MuiMenu-paper': {
            borderTopRightRadius: 0,
          },
          '& .MuiList-root': {
            '& .MuiMenuItem-root': {
              '&:hover': {
                '& *': {
                  color: palette.menu.item.hoverText,
                },
              },
            },
          },
        }}
      >
        {children}
      </Menu>
    </>
  );
};
